export function callableFailureMessage(error) {
    const code = typeof error?.code === "string" ? error.code : "";
    const detail = typeof error?.details === "string" ? error.details : "";
    const raw = typeof error?.message === "string" ? error.message : detail;
    const text = raw.replace(/^FirebaseError:\s*/i, "").trim();
    const busy = code === "functions/aborted" || code === "aborted"
        || /account operation is in progress|requires reconciliation|unacknowledged operation/i.test(text);
    if (busy && /unacknowledged/i.test(text)) {
        return "The account change did not finish cleanly. Refresh this user and try again. If the same error remains, an administrator needs to clear that user's account operation lock.";
    }
    if (busy) {
        return "This account already has a change in progress or waiting for reconciliation, so nothing was saved. Wait a few minutes and try again. If this user stays blocked, an administrator needs to clear the Active field on their account operation document in Firestore. Other users are not affected.";
    }
    if (/permission changed/i.test(text)) {
        return "That permission changed before it could be saved. Refresh the user and try again.";
    }
    return text;
}
